import store from 'Site/js/store';
import Vue from 'vue';
import AdvertCreate from 'Adverts/component/AdvertCreate.vue';
import MeetForm from 'Adverts/component/MeetForm.vue';

function create() {
    const json = store.state.config;

    if (json.data.meet === 'meet' || json.data.meet === '1') {

        new Vue({ /* eslint no-new: 0 */
            el: '#page-body',
            name: 'meetFormPage',
            store,
            components: {
                MeetForm
            },
            methods: {
                deleteMeet() {
                    window.location.reload();
                },
                submitMeet({ id }) {
                    window.location = json.pages.advert.replace('CHANGE_ME', id);
                }
            }
        });
    } else {
        new Vue({ /* eslint no-new: 0 */
            el: '#page-body',
            name: 'advertCreatePage',
            store,
            components: {
                AdvertCreate
            }
        });
    }
}

export default {
    'addys-new': create,
    'addys-advert-edit': create
};
